import { PaginatedQueryResponse } from '@/types/api'
import { IToolSuggestion } from '@/types/tool-suggestion'
import { ApiService } from './ApiService'

export class ToolsService extends ApiService {
  static GET_PATH = '/tools'

  static async searchTools(
    q: string,
    page: number = 1,
    limit: number = 5
  ): Promise<PaginatedQueryResponse<IToolSuggestion>> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    })
    if (q.trim()) params.set('q', q.trim())
    const raw = await ApiService.get(`${ToolsService.GET_PATH}?${params}`)
    const data = Array.isArray(raw?.data)
      ? raw.data
      : Array.isArray(raw)
        ? raw
        : []
    const metadata = raw?.metadata ?? { page, limit, total: data.length }
    return { data, metadata }
  }
}
